<template>
  <Table :loading="showLoading" empty-text="" style="width: 100vw;height: 100vh"></Table>
</template>

<script>

import {setCookie} from "../../../../utils/cookieUtil";

export default {
  name: "Loading",
  data() {
    return {
      showLoading: true
    }
  },
  mounted() {
    const data = JSON.parse(this.$route.query.data)
    setCookie(global.cookieName, data.name);
    setCookie("Authorization", data.token);
    setCookie(global.companyId, data.companyId);
    localStorage.setItem('companyId', data.companyId);
    localStorage.setItem('userId', data.userId);
    localStorage.setItem('token', data.token);
    localStorage.setItem('name', data.name);
    localStorage.setItem("locale", data.locale);
    this.$i18n.locale = data.locale;
    this.$api.security
      .userMenu("userName", data.name)
      .then(res => {
        if (res.data.length <= 0) {
          this.$Message.error(this.$t('permission_configuration_management.user.noMenuContactAdmin'))
          setTimeout(() => {
            this.$router.back()
          }, 2000)
          return
        }
        this.saveObjArr("router", res.data); //存储路由到localStorage
        if (res.data[0].type == undefined) {
          this.$router.replace(res.data[0].path);
        } else {
          this.$router.replace(
            res.data[0].children[0].path
          );
        }
      }).catch(() => {
      setTimeout(() => {
        this.$router.back()
      }, 2000)
    });
  },
  methods: {
    saveObjArr(name, data) {
      localStorage.setItem(name, JSON.stringify(data));
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/user/Loading.vue